import React from 'react';

import { UserSkillBadge } from '@/components/settings/UserSkillBadge';
import { Skeleton } from '@/components/ui/skeleton';
import { useUserSkills } from '@/hooks/useUserSkills';

interface MemberSkillsCellProps {
  organizationId: string;
  userId?: string;
}

/**
 * Renders a member's skills as badges within the organization members table.
 * Fetches per user via getUserSkills (cached by React Query). Only mounted
 * when the viewer has permission to read skills, so it never fires 403s.
 */
export const MemberSkillsCell: React.FC<MemberSkillsCellProps> = ({ organizationId, userId }) => {
  const { data, isLoading } = useUserSkills(organizationId, userId);
  const skills = data?.skills || [];

  if (isLoading) {
    return <Skeleton className="h-5 w-24" />;
  }

  if (skills.length === 0) {
    return <span className="text-sm text-muted-foreground">—</span>;
  }

  return (
    <div className="flex flex-wrap gap-1">
      {skills.map(skill => (
        <UserSkillBadge key={skill.skill} skill={skill} />
      ))}
    </div>
  );
};
